import { Component, Input, OnInit } from '@angular/core';
import {
  BaseLoginComponent,
  PageType,
} from 'src/app/shared/components/base-login/base-login.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-suguyaku',
  templateUrl: './suguyaku.component.html',
  styleUrls: ['../style/global.css', './suguyaku.component.css'],
})
export class SuguyakuComponent
  extends BaseLoginComponent
  implements OnInit {
  @Input()
  clientId: string;

  password = '';
  firstName = '';
  lastName = '';

  inputState = {
    email: { isFocus: false },
    password: { isFocus: false },
    confirmPassword: { isFocus: false },
    firstName: { isFocus: false },
    lastName: { isFocus: false },
  };
  passwordState: 'text' | 'password' = 'password';

  page: PageType;

  titleMaps() {
    return {
      'forgot-password': 'パスワードを忘れた方 | すぐ薬',
      'password-reset-send':
        'リセット用URLをメールで送信しました | すぐ薬',
      login: 'ログイン | すぐ薬',
      register: '新規登録 | すぐ薬',
      'register-resend': '',
    };
  }

  async ngOnInit() { }

  focus(val: { isFocus: boolean }) {
    val.isFocus = true;
  }
  blur(val: { isFocus: boolean }) {
    val.isFocus = false;
  }

  get inputLabelClass() {
    if (this.email.length || this.inputState.email.isFocus)
      return 'v-label theme--light v-label--active primary--text';
    return 'v-label theme--light';
  }
  get passwordLabelClass() {
    if (this.password.length || this.inputState.password.isFocus)
      return 'v-label theme--light v-label--active primary--text';
    return 'v-label theme--light';
  }

  get confirmPasswordLabelClass() {
    if (this.confirmPassword.length || this.inputState.confirmPassword.isFocus)
      return 'v-label theme--light v-label--active primary--text';
    return 'v-label theme--light';
  }

  get givennameLabelClass() {
    if (this.firstName.length || this.inputState.firstName.isFocus)
      return 'v-label theme--light v-label--active primary--text';
    return 'v-label theme--light';
  }

  get familyNameLabelClass() {
    if (this.lastName.length || this.inputState.lastName.isFocus)
      return 'v-label theme--light v-label--active primary--text';
    return 'v-label theme--light';
  }

  get checkedStyle() {
    if (!this.acceptTerm) {
      return {
        i: `v-icon notranslate mdi mdi-checkbox-blank-outline theme--light`,
        div: `v-input--selection-controls__ripple`,
      };
    }
    return {
      i: `v-icon notranslate mdi mdi-checkbox-marked theme--light primary--text`,
      div: `v-input--selection-controls__ripple primary--text`,
    };
  }

  check() {
    this.acceptTerm = !this.acceptTerm;
  }

  async changePassword(): Promise<void> {
    if (!this.email) {
      this.errorMessages.forgetpassword.email =
        'メールアドレスを入力してください。';
      return;
    } else {
      this.errorMessages.forgetpassword.email = undefined;
    }

    const result = await super.changePassword();
    this.navigate('password-reset-send');
    return result;
  }

  /** 登録時のロール設定. フォームから指定する */
  protected registrationRole(): string {
    // TODO デザインに合わせて実装
    return undefined;
  }

  get isOem() {
    return /oem/g.test(environment.apps[this.clientId].type);
  }
  get termsUrl() {
    return environment.apps[this.clientId].termUrl;
  }
  get privacyUrl() {
    return environment.apps[this.clientId].privacyUrl;
  }
}
